<template>
  <div ref="containerRef">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import type { UseIntersectionObserverOptions } from '@vueuse/core'

import { useIntersectionObserver } from '@vueuse/core'
import { onBeforeUnmount, ref } from 'vue'

interface Props {
  options?: UseIntersectionObserverOptions
}

const props = defineProps<Props>()

const emits =
  defineEmits<{
    (event: 'visibilityChange', isVisible: boolean): void
  }>()

const containerRef = ref<HTMLElement | null>(null)

const { stop } = useIntersectionObserver(
  containerRef,
  ([{ isIntersecting }], _observerElement) => {
    emits('visibilityChange', isIntersecting)
  },
  props.options
)

onBeforeUnmount(() => {
  stop()
})
</script>
